import axiosInstance from "../../../api/axiosConfig";
import type {
  NotificationPreferences,
  NotificationsPage,
  TypePreference
} from "../types";

// `axiosInstance.baseURL` already ends in `/api`.
const BASE = "/notifications";

export const NotificationsAPI = {
  async list(
    opts: {
      unreadOnly?: boolean;
      cursor?: number | null;
      limit?: number;
    } = {}
  ): Promise<NotificationsPage> {
    const params: Record<string, string> = {};
    if (opts.unreadOnly) params.unread = "1";
    if (opts.cursor != null) params.cursor = String(opts.cursor);
    if (opts.limit) params.limit = String(opts.limit);
    const { data } = await axiosInstance.get<NotificationsPage>(BASE, {
      params
    });
    return {
      items: data.items ?? [],
      next_cursor: data.next_cursor ?? null,
      unread_count: data.unread_count ?? 0,
      has_unseen: Boolean(data.has_unseen)
    };
  },
  /** Clears the "new" dot without marking rows read. */
  async markSeen(): Promise<void> {
    await axiosInstance.post(`${BASE}/seen`, {});
  },
  async markRead(ids: string[]): Promise<{ unread_count: number }> {
    const { data } = await axiosInstance.post<{ unread_count: number }>(
      `${BASE}/read`,
      { ids }
    );
    return data;
  },
  /** `context` (e.g. `{thread_id}`) limits the sweep to matching rows. */
  async markAllRead(
    context?: Record<string, unknown> | null
  ): Promise<{ read: number; unread_count: number }> {
    const { data } = await axiosInstance.post<{
      read: number;
      unread_count: number;
    }>(`${BASE}/read-all`, context ? { context } : {});
    return data;
  },
  async getPreferences(): Promise<NotificationPreferences> {
    const { data } = await axiosInstance.get<NotificationPreferences>(
      `${BASE}/preferences`
    );
    return data;
  },
  async updatePreferences(patch: {
    quiet?: boolean;
    per_type?: Record<string, Partial<TypePreference>>;
  }): Promise<NotificationPreferences> {
    const { data } = await axiosInstance.put<NotificationPreferences>(
      `${BASE}/preferences`,
      patch
    );
    return data;
  }
};

export const PresenceAPI = {
  async heartbeat(): Promise<void> {
    await axiosInstance.post("/presence/heartbeat", {});
  }
};
